__turbopack_context__.v({
  "error": "site-notification-module-sass-module__GDw41q__error",
  "info": "site-notification-module-sass-module__GDw41q__info",
  "modalButton": "site-notification-module-sass-module__GDw41q__modalButton",
  "modalText": "site-notification-module-sass-module__GDw41q__modalText",
  "modalTitle": "site-notification-module-sass-module__GDw41q__modalTitle",
  "notification": "site-notification-module-sass-module__GDw41q__notification",
  "success": "site-notification-module-sass-module__GDw41q__success",
  "warning": "site-notification-module-sass-module__GDw41q__warning",
});
